import { render, staticRenderFns } from "./MyLoading.vue?vue&type=template&id=2b30d5d0&scoped=true"
import script from "./MyLoading.vue?vue&type=script&lang=js"
export * from "./MyLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30d5d0",
  null
  
)

export default component.exports